module.exports = __webpack_public_path__ + "static/media/sa.8f3e4e41.svg";